<script>
    // Логотип JUST RP: знак (щит с монограммой JR и звездой Сан-Андреас) и,
    // по желанию, шрифтовая часть. Раньше в шапках стояла просто буква «J» —
    // это выглядело как заглушка. Здесь векторный знак, поэтому он одинаково
    // чёткий и в худе (мелко), и на экране входа (крупно).
    export let size = 34;      // размер знака в пикселях
    export let text = true;    // показывать надпись JUST RP рядом
    export let title = '';     // подпись под надписью (раздел, магазин и т.п.)

    // у каждого экземпляра свой id градиента, иначе второй логотип на странице
    // подхватил бы градиент первого и стал бы серым
    const uid = 'jrb' + Math.random().toString(36).slice(2, 8);
</script>

<div class="jrb" style="--s:{size}px">
    <svg class="jrb-mark" viewBox="0 0 48 48" width={size} height={size} aria-hidden="true">
        <defs>
            <linearGradient id="{uid}g" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stop-color="#f6d488" />
                <stop offset="45%" stop-color="#e7ae3f" />
                <stop offset="100%" stop-color="#b8721f" />
            </linearGradient>
            <linearGradient id="{uid}s" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#fff" stop-opacity=".55" />
                <stop offset="55%" stop-color="#fff" stop-opacity="0" />
            </linearGradient>
        </defs>
        <!-- щит -->
        <path d="M24 2.5 42.5 9v16.5c0 9.6-7.4 17-18.5 20.9C12.9 42.5 5.5 35.1 5.5 25.5V9L24 2.5Z"
              fill="url(#{uid}g)" />
        <path d="M24 2.5 42.5 9v16.5c0 9.6-7.4 17-18.5 20.9C12.9 42.5 5.5 35.1 5.5 25.5V9L24 2.5Z"
              fill="url(#{uid}s)" />
        <!-- внутренняя рамка -->
        <path d="M24 6.6 38.7 11.8v13.7c0 7.7-6 13.8-14.7 17.1-8.7-3.3-14.7-9.4-14.7-17.1V11.8L24 6.6Z"
              fill="none" stroke="#2a1c06" stroke-opacity=".55" stroke-width="1.1" />
        <!-- монограмма JR -->
        <path d="M18.6 15.4h3.9v11.1c0 3.4-1.9 5.2-5 5.2-1.6 0-2.9-.4-3.9-1.2l1.3-3c.6.5 1.3.8 2.1.8 1.1 0 1.6-.6 1.6-2V15.4Z"
              fill="#2a1c06" />
        <path d="M25.4 15.4h6.2c3.3 0 5.4 1.8 5.4 4.7 0 1.9-.9 3.3-2.5 4.1l2.9 4.9h-4.2l-2.4-4.2h-1.5v4.2h-3.9V15.4Zm5.9 6.6c1.1 0 1.7-.6 1.7-1.7 0-1.1-.6-1.6-1.7-1.6h-2v3.3h2Z"
              fill="#2a1c06" />
        <!-- звезда снизу -->
        <path d="m24 33.4 1.15 2.4 2.6.36-1.9 1.83.46 2.6L24 39.36l-2.31 1.23.46-2.6-1.9-1.83 2.6-.36L24 33.4Z"
              fill="#2a1c06" fill-opacity=".8" />
    </svg>

    {#if text}
        <div class="jrb-text">
            <span class="jrb-name">JUST<b>RP</b></span>
            {#if title}<span class="jrb-sub">{title}</span>{/if}
        </div>
    {/if}
</div>

<style>
    .jrb { display: flex; align-items: center; gap: .55em; }
    .jrb-mark { display: block; filter: drop-shadow(0 .18em .5em rgba(231, 174, 63, .35)); flex-shrink: 0; }
    .jrb-text { display: flex; flex-direction: column; line-height: 1.05; }
    .jrb-name {
        font-family: 'Unbounded', 'Manrope', sans-serif;
        font-weight: 800;
        font-size: calc(var(--s) * .46);
        letter-spacing: .06em;
        color: #fff;
    }
    .jrb-name b { color: #e7ae3f; font-weight: 800; }
    .jrb-sub {
        margin-top: .25em;
        font-family: 'Manrope', sans-serif;
        font-weight: 700;
        font-size: calc(var(--s) * .26);
        letter-spacing: .2em;
        text-transform: uppercase;
        color: rgba(243, 234, 214, .5);
    }
</style>
